// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const CLOSE_STICKY_RECTANGLE = "zavrie\u0165 reklamu";
